import { Alert, AlertTitle, AlertDescription } from "@/components/ui/alert";
import { Trash2 } from "lucide-react";
import { useTranslation } from "react-i18next";

interface DeletedWarningProps {
  show?: boolean;
  title?: string;
  description?: string;
}

export default function DeletedWarning({
  show,
  title,
  description,
}: DeletedWarningProps) {
  const { t } = useTranslation();

  if (!show) {
    return null;
  }

  return (
    <Alert className="bg-yellow-100 text-yellow-900 border-yellow-300 mb-2">
      <Trash2 className="w-5 h-5" color="#713f12" />
      <AlertTitle>{title ?? t("common.deleted.title")}</AlertTitle>
      <AlertDescription>
        {description ?? t("common.deleted.description")}
      </AlertDescription>
    </Alert>
  );
}
